import { Link } from 'react-router-dom';

interface ArticleCardProps {
  article: {
    id: number;
    title: string;
    excerpt: string;
    cover: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    views: string;
    tags: string[];
  };
  variant?: 'horizontal' | 'vertical';
}

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  tiyu: '体育',
  yinyue: '音乐',
  youxi: '游戏',
};

export default function ArticleCard({ article, variant = 'vertical' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="flex gap-4 p-3 rounded-lg bg-background-100 hover:bg-background-200/50 transition-colors cursor-pointer group"
      >
        <div className="w-40 h-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-100 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
            {article.title}
          </h4>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{article.excerpt}</p>
          <div className="flex items-center gap-3 mt-2 text-xs text-foreground-600">
            <span className="text-accent-400">{categoryNames[article.category] || article.category}</span>
            <span>{article.date}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="block rounded-lg bg-background-100 overflow-hidden hover:bg-background-200/50 transition-colors cursor-pointer group"
    >
      <div className="h-44 overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-xs text-accent-400 bg-accent-500/10 px-2 py-0.5 rounded whitespace-nowrap">
            {categoryNames[article.category] || article.category}
          </span>
          {article.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <h4 className="text-sm font-medium text-foreground-100 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
          {article.title}
        </h4>
        <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
        <div className="flex items-center justify-between mt-3 text-xs text-foreground-600">
          <div className="flex items-center gap-2">
            <span>{article.author}</span>
            <span>·</span>
            <span>{article.date}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            <span>{article.views}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}